'use client';

import Script from 'next/script';

import { useCustomerKey } from './useCustomerKey';
import { useOneTrustParams } from './useOneTrustParams';

export const OneTrustV2 = () => {
    const { customerKey } = useCustomerKey();
    const { token } = useOneTrustParams({ customerKey });

    if (!customerKey || !token) return null;

    const payload = {
        dataSubjectParams: { id: customerKey, isAnonymous: false, token },
    };

    return (
        <Script
            id="OneTrust-Cross-Domain"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html:
                    `window.OneTrust = window.OneTrust || {};` +
                    `Object.assign(window.OneTrust, ${JSON.stringify(payload)});`,
            }}
        />
    );
};
